import type React from "react"
import { Alert } from "react-bootstrap"
import "./notification.css"
import { NotificationPayload, NotificationType } from "../../../utils/pubsub"

type NotificationComponentProps = {
  payload: NotificationPayload
  setNotification: (value: boolean) => void
}

const Notification: React.FC<NotificationComponentProps> = ({ payload, setNotification }) => {
  // Fallbacks for missing/null props
  const type = payload?.type || NotificationType.Info
  const title = payload?.title || (() => {
  switch (type) {
    case NotificationType.Success:
      return "Success"
    case NotificationType.Failure:
      return "Failure"
    case NotificationType.Warning:
      return "Warning"
    case NotificationType.Info:
    default:
      return "Info"
  }
})()



  const message = payload?.message || ""

  const getIcon = (type: NotificationType) => {
    switch (type) {
      case NotificationType.Success:
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
              stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            />
            <path d="M9 22V12H15V22" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )
      case NotificationType.Failure:
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )
      case NotificationType.Warning:
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            />
          </svg>
        )
      case NotificationType.Info:
      default:
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            />
          </svg>
        )
    }
  }

  const getIconClass = (type: NotificationType) => {
    switch (type) {
      case NotificationType.Success:
        return "success"
      case NotificationType.Failure:
        return "danger"
      case NotificationType.Warning:
        return "warning"
      case NotificationType.Info:
      default:
        return "info"
    }
  }

  // Map NotificationType to react-bootstrap Alert variant strings
  const getAlertVariant = (type: NotificationType): "success" | "danger" | "warning" | "info" => {
    switch (type) {
      case NotificationType.Success:
        return "success"
      case NotificationType.Failure:
        return "danger"
      case NotificationType.Warning:
        return "warning"
      case NotificationType.Info:
      default:
        return "info"
    }
  }
  return (
    <div className="notification">
      <Alert variant={getAlertVariant(type)} className="fade alert show">
        <div className="notification-content">
          <div className={`notification-icon ${getIconClass(type)}`}>
            {payload?.icon ? payload.icon : getIcon(type)}
          </div>
          <div className="notification-text">
            <div className="notification-title">{title}</div>
           <p dangerouslySetInnerHTML={{ __html: message }} />

          </div>
        </div>
        <button
          className="notification-close"
          onClick={() => setNotification(false)}
          aria-label="Close notification"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#6b7280"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </Alert>
    </div>
  )
}

export default Notification
